// before each route
// check if user isAuthenticated
// check if userAuth to view page
// check if userRole can view page

import VueRouter from 'vue-router'
import store from '@/store'

import { signIn, signOut } from '@/services/entraAuth'

export function routeGuard(router: VueRouter): unknown {
  return router.beforeEach(async (to, from, next) => {
    if (store.state.isAuthenticated == true) {
      const authUsers = to.meta?.authorizedUsers,
        userRoles = store.state.userInfo?.userRole
          ? store.state.userInfo?.userRole
          : [0]
      if (authUsers && userRoles) {
        authUsers.some((r) => {
          if (!userRoles.includes(r)) {
            next({ name: '403' })
          } else {
            next()
          }
        })
      } else {
        next()
      }
      if (to.name == 'Log Out') {
        signOut()
      }
    } else {
      signIn().then(() => next())
    }

    return true
  })
}
